module.exports = __webpack_public_path__ + "static/scale-model-of-ghost-party-tours-in-tampa-florida-9d865942456a04f80440592190660920.png";